export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/cloud-02.b796d0f3-8a84e9.svg";